module.exports = __webpack_public_path__ + "0398d61d075776dfef177b043a139d07.fbx";